export const UNIDAD_DESCUENTO = {
  VALOR_MONETARIO: 'ValorMonetario',
  PORCENTAJE: 'Porcentaje'
} as const;

export type UnidadDescuento = typeof UNIDAD_DESCUENTO[keyof typeof UNIDAD_DESCUENTO];
